import { render, staticRenderFns } from "./taxStartingDetailsStep.vue?vue&type=template&id=6d3846f0&"
import script from "./taxStartingDetailsStep.vue?vue&type=script&lang=js&"
export * from "./taxStartingDetailsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports